/* eslint-disable react-hooks/exhaustive-deps */
import { ArrowRightOutlined } from '@ant-design/icons';
import { Form, Input, Space, Radio, Button } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
const { TextArea } = Input;
export default function Stap1(props) {
    const [openPurpose, setOpenPurpose] = useState();
    const onNextStep = () => {
        props.nextStep();
        if (props?.form?.getFieldsValue()?.applicantRole === 1) {
            props?.personalInformation.resetFields();
            props?.getPersonalType();
        }
    };

    return (
        <div
            className="rounded-md p-5 h-full"
            style={{
                backgroundColor: props?.customStyle?.bgColor, //bgColor
            }}
        >
            <div
                className="space-y-3"
                style={{
                    color: props?.fontStyle?.textCardColor,
                }}
            >
                <div className="text-xl font-bold px-3">
                    1.{' '}
                    {props.lang === 'TH'
                        ? 'ข้อมูลเกี่ยวกับผู้ยื่นคำร้อง'
                        : 'Information of the Requester'}
                </div>
                <div style={{ border: '1px solid #DBDBDB' }}></div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    name="step1"
                    form={props.form}
                    layout="vertical"
                    className="px-3"
                >
                    <Form.Item
                        className="mt-4"
                        name="applicantRole"
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                        label={
                            <div
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                }}
                                className="font-bold text-xl"
                            >
                                {props.lang === 'TH'
                                    ? 'เลือกบทบาทผู้ยื่นคำร้อง'
                                    : 'Requester role'}
                            </div>
                        }
                    >
                        <Radio.Group
                            onChange={(e) => {
                                // console.log(e.target.value);
                                setOpenPurpose(e.target.value);
                            }}
                            size="large"
                        >
                            <Space direction="vertical">
                                <Radio
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    key={1}
                                    value={0}
                                >
                                    {props.lang === 'TH'
                                        ? 'ฉันเป็นเจ้าของข้อมูล'
                                        : 'The applicant is the data subject'}
                                </Radio>
                                <Radio
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    key={2}
                                    value={1}
                                >
                                    {' '}
                                    {props.lang === 'TH'
                                        ? 'ฉันเป็นผู้แทนในการยื่นคำร้อง'
                                        : 'The applicant is the agent of the data subject'}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                    {openPurpose === 1 && (
                        <Form.Item
                            hidden={false}
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH'
                                        ? 'เหตุผลในการดำเนินการแทน (Purpose)'
                                        : 'Reason for request instead of the data subject'}
                                </div>
                            }
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                            name="purpose"
                        >
                            <TextArea
                                size="large"
                                autoSize={{ minRows: 5 }}
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'เหตุผลในการดำเนินการแทน (Purpose)'
                                        : 'Additional details'
                                }
                            />
                        </Form.Item>
                    )}
                    <div
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                        className="text-xl font-bold pb-1"
                    >
                        {props.lang === 'TH'
                            ? 'รายละเอียดเบื้องต้นเกี่ยวกับผู้ยื่นคำร้อง'
                            : 'Contact details of Requester'}
                    </div>
                    {/* Firstname Lastname */}
                    <div
                        className={classNames(
                            'gap-x-3',
                            {
                                'grid grid-cols-2':
                                    props?.platform === 'Desktop',
                            },
                            {
                                'grid grid-cols-2':
                                    props?.platform === 'Tablet',
                            },
                            {
                                block: props?.platform === 'Mobile',
                            }
                        )}
                        // className="sm:block md:grid sm:grid-cols-1 md:grid-cols-2 gap-x-3"
                    >
                        <Form.Item
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH' ? 'ชื่อ' : 'Name'}
                                </div>
                            }
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder={
                                    props.lang === 'TH' ? 'ชื่อ' : 'Name'
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH'
                                        ? 'นามสกุล'
                                        : 'Surname'}
                                </div>
                            }
                            name="lastName"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder={
                                    props.lang === 'TH' ? 'นามสกุล' : 'Surname'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* Address */}
                    <div
                        className={classNames(
                            {
                                'grid grid-cols-1':
                                    props?.platform === 'Desktop',
                            },
                            {
                                'grid grid-cols-1':
                                    props?.platform === 'Tablet',
                            },
                            {
                                block: props?.platform === 'Mobile',
                            }
                        )}
                        // className="sm:block md:grid grid-cols-1"
                    >
                        <Form.Item
                            hidden={false}
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH'
                                        ? 'ที่อยู่'
                                        : 'Address'}
                                </div>
                            }
                            name="address"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder={
                                    props.lang === 'TH' ? 'ที่อยู่' : 'Address'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* Telephone Email */}
                    <div
                        className={classNames(
                            {
                                flex: props?.platform === 'Desktop',
                            },
                            {
                                flex: props?.platform === 'Tablet',
                            },
                            {
                                block: props?.platform === 'Mobile',
                            }
                        )}
                        // className="sm:block md:flex"
                    >
                        <Form.Item
                            //flex-basis phone check by email
                            style={{ flexBasis: false ? '100%' : '50%' }}
                            hidden={false}
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH'
                                        ? 'หมายเลขโทรศัพท์'
                                        : 'Telephone number'}
                                </div>
                            }
                            name="phone"
                            rules={[
                                {
                                    // ^[0-9]\d*$
                                    pattern: new RegExp(/[0-9]/),
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ถูกต้อง'
                                            : 'Telephone number is not a valid.',
                                },
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                maxLength={10}
                                size="large"
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'หมายเลขโทรศัพท์'
                                        : 'Telephone number'
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            style={{
                                flexBasis: false ? '100%' : '50%',
                            }}
                            className={classNames(
                                {
                                    'pl-3': props?.platform === 'Desktop',
                                },
                                {
                                    'pl-3': props?.platform === 'Tablet',
                                },
                                {
                                    'pl-0': props?.platform === 'Mobile',
                                }
                            )}
                            hidden={false}
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH' ? 'อีเมล' : 'Email'}
                                </div>
                            }
                            name="email"
                            rules={[
                                {
                                    type: 'email',
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ถูกต้อง'
                                            : 'Email is not a valid.',
                                },
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'this field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder={
                                    props.lang === 'TH' ? 'อีเมล' : 'Email'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* CardID */}
                    <div
                        className={classNames(
                            {
                                'grid grid-cols-1':
                                    props?.platform === 'Desktop',
                            },
                            {
                                'grid grid-cols-1':
                                    props?.platform === 'Tablet',
                            },
                            {
                                block: props?.platform === 'Mobile',
                            }
                        )}
                        // className="sm:block md:grid grid-cols-1"
                    >
                        <Form.Item
                            hidden={false}
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH'
                                        ? 'หมายเลขบัตรประจำตัวประชาชน / passport'
                                        : 'Identification Number / passport'}
                                </div>
                            }
                            name="cardId"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                maxLength={13}
                                size="large"
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'หมายเลขบัตรประจำตัวประชาชน / passport'
                                        : 'Identification Number / passport'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* Infomation */}
                    <Form.Item
                        hidden={false}
                        label={
                            <div
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                    fontSize: props?.fontStyle?.fontSize,
                                }}
                                className="font-bold"
                            >
                                {props.lang === 'TH'
                                    ? 'รายละเอียดอื่น (ถ้ามี)'
                                    : 'Additional details (if any)'}
                            </div>
                        }
                        name="information"
                    >
                        <TextArea
                            size="large"
                            autoSize={{ minRows: 5 }}
                            placeholder={
                                props.lang === 'TH'
                                    ? 'รายละเอียดอื่น'
                                    : 'Additional details'
                            }
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            style={{
                                backgroundColor:
                                    props?.customStyle?.buttonColor,
                                color: props?.fontStyle?.textButtonColor,
                                borderColor: props?.customStyle?.buttonColor,
                            }}
                            className="w-[120px]"
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                        >
                            {props.lang === 'TH' ? 'ถัดไป' : 'Next'}
                            <ArrowRightOutlined />
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
